import { Category } from '../../generated/graphql';

export const extractCategoryName = (name: string): string =>
  name.startsWith('doshii:menu:') ? name.split(':').slice(3).join(':') || name : name;

export const extractMenuName = (name: string): string => (name.startsWith('doshii:menu:') ? name.split(':')[2] : '');

type SplitMenuInput = {
  categories: Category[];
  venueName: string;
};

type SplitMenuResult = {
  id: string;
  displayName: string;
  usesDoshiiMenuLogic: boolean;
  categories: Category[];
};

/**
 * Splits the whole menu into smaller menus using `doshii:menu` logic.
 * It always puts categories without `doshii:menu` first in the list.
 * But if there are no categories without `doshii:menu`, then the function is going to skip this section.
 */
export const splitMenu = ({ categories, venueName }: SplitMenuInput): SplitMenuResult[] => {
  const venueCategories: Category[] = [];
  const categoriesByMenu: { [key: string]: Category[] } = {};
  categories.forEach((category) => {
    if (category.category.startsWith('doshii:menu:')) {
      const categoryDisplayName = category.category.split(':')[2];
      if (categoriesByMenu[categoryDisplayName]) {
        categoriesByMenu[categoryDisplayName].push(category);
      } else {
        categoriesByMenu[categoryDisplayName] = [category];
      }
    } else {
      venueCategories.push(category);
    }
  });

  return [
    ...(venueCategories.length === 0
      ? []
      : [
          {
            id: venueName,
            displayName: venueName,
            usesDoshiiMenuLogic: false,
            categories: venueCategories
          }
        ]),
    ...Object.keys(categoriesByMenu).map((name) => ({
      id: `doshii:menu:${name}`,
      displayName: name,
      categories: categoriesByMenu[name],
      usesDoshiiMenuLogic: true
    }))
  ];
};
